import { tmxApiCall } from './index'

export default {
  async confirmVerificationCode (verificationNumber, applicationId, optIn) {
    return tmxApiCall('post', '/customerCommunicationOptin', {
      verificationNumber,
      applicationId,
      optIn
    })
  },

  async updateCommunication (applicationId, optIn, resendCode, cellPhoneNumber, skipVerification) {
    return tmxApiCall('put', '/customerCommunicationOptin', {
      applicationId,
      optIn,
      resendCode,
      cellPhoneNumber,
      skipVerification
    })
  }
}
